// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"swap-right"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 14L20 14L15 9","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const SwapRightIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'swap-right',
    ref,
    icon: element,
  },
));

SwapRightIcon.displayName = 'SwapRightIcon';

export default SwapRightIcon;
